import { useTranslation } from 'react-i18next';
import { Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { isEmpty } from 'lodash';
import { getEmployeeNames } from '../../../../CalendarUtils';
import { OrderStatus, PropelUserModel } from '../../../../../api';

type ManagementPanelSummaryProps = {
  selectedUsersIds: string[];
  users: PropelUserModel[];
  comment?: string;
  isEventOrderPage?: boolean;
  shouldHideUsers?: boolean;
  orderStatus?: OrderStatus;
};
export const ManagementPanelSummary = ({
  selectedUsersIds,
  users,
  comment,
  isEventOrderPage,
  shouldHideUsers,
  orderStatus,
}: ManagementPanelSummaryProps) => {
  const { t } = useTranslation();
  return (
    <Grid container direction="column" gap={0.5}>
      {!isEventOrderPage && !shouldHideUsers && (
        <Grid container gap={0.5} wrap="nowrap">
          <Typography variant="body1" color="text.secondary">
            {t('calendar.edit_event.employees')}
          </Typography>
          <Typography variant="body1" sx={{ minWidth: 0 }}>
            {isEmpty(selectedUsersIds)
              ? t('calendar.edit_event.noemployees')
              : getEmployeeNames(selectedUsersIds, users).join(', ')}
          </Typography>
        </Grid>
      )}
      <Grid container gap={0.5} wrap="nowrap">
        <Typography variant="body1" color="text.secondary">
          {t('calendar.edit_event.comment')}
        </Typography>
        {isEmpty(comment) ? (
          <Typography variant="body1">{t('calendar.edit_event.noemployees')}</Typography>
        ) : (
          <Tooltip title={comment}>
            <Typography variant="body1" noWrap sx={{ flex: 1, minWidth: 0 }}>
              {comment}
            </Typography>
          </Tooltip>
        )}
      </Grid>
      {orderStatus && (
        <Grid container gap={0.5} wrap="nowrap">
          <Typography variant="body1" color="text.secondary">
            {t('calendar.edit_event.status')}
          </Typography>
          <Typography variant="body1">{t(`order_status.${orderStatus?.toLowerCase()}`)}</Typography>
        </Grid>
      )}
    </Grid>
  );
};
